const server={
  url: "https://apiportalmanager.mayaland.store" //PRODUCCION
  // url: "https://backv2.portalmanager.pro" // BACKEND V2
  // url: "http://localhost:4800"
}

export const elixir={
  url:"https://portalmanager.pro"
}
export default server
